/**
 * @generated SignedSource<<d72564a7a71871b1dffc51050ccc3782>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyncGitlabDataInput = {
  projectId: string;
  gitlabProjectId?: string | null;
  gitlabProjectName?: string | null;
  server?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type syncGitlabDataMutation$variables = {
  input: SyncGitlabDataInput;
};
export type syncGitlabDataMutation$data = {
  readonly syncGitlabData: {
    readonly project: {
      readonly gitlabProjectId: string | null;
      readonly gitlabProjectName: string | null;
      readonly gitlabServerProjectId: string | null;
    } | null;
  } | null;
};
export type syncGitlabDataMutation = {
  variables: syncGitlabDataMutation$variables;
  response: syncGitlabDataMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabProjectId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabProjectName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabServerProjectId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "syncGitlabDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SyncGitlabDataPayload",
        "kind": "LinkedField",
        "name": "syncGitlabData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "syncGitlabDataMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SyncGitlabDataPayload",
        "kind": "LinkedField",
        "name": "syncGitlabData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c44cedfb0fcc82f4d71506d89fd90cab",
    "id": null,
    "metadata": {},
    "name": "syncGitlabDataMutation",
    "operationKind": "mutation",
    "text": "mutation syncGitlabDataMutation(\n  $input: SyncGitlabDataInput!\n) {\n  syncGitlabData(input: $input) {\n    project {\n      gitlabProjectId\n      gitlabProjectName\n      gitlabServerProjectId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "24b334c15e33a6ee4cdbe969ef0a5339";

export default node;
